<template>
  <div class="user-list">
    <el-row>
      <el-button size="small" class="pull-right" type="primary" @click="handleSearch">搜索
      </el-button>
      <el-col class="pull-right" style="width: 200px; margin-right: 20px">
        <el-input size="small" v-model="params.user_tag" placeholder="用户标签"></el-input>
      </el-col>
      <el-col class="pull-right" style="width: 200px; margin-right: 20px">
        <el-select size="small" v-model="params.type" placeholder="用户类型">
          <el-option value label="全部">全部</el-option>
          <el-option :value="1" label="普通用户">普通用户</el-option>
          <el-option :value="2" label="主播">主播</el-option>
          <el-option :value="7" label="主播（新）">主播（新）</el-option>
          <el-option :value="3" label="测试账号">测试账号</el-option>
          <el-option :value="4" label="自定义用户">自定义用户</el-option>
          <el-option :value="6" label="自定义用户">试用期代理</el-option>
          <el-option :value="9" label="自定义用户">JZS用户</el-option>
        </el-select>
      </el-col>
      <el-col class="pull-right" style="width: 200px; margin-right: 20px">
        <el-select size="small" v-model="params.status" placeholder="用户状态搜索">
          <el-option value label="全部">全部</el-option>
          <el-option :value="1" label="正常">正常</el-option>
          <el-option :value="2" label="冻结">冻结</el-option>
        </el-select>
      </el-col>
      <el-col class="pull-right" style="width: 200px; margin-right: 20px">
        <el-input size="small" v-model="params.name" placeholder="用户名搜索"></el-input>
      </el-col>
      <el-col class="pull-right" style="width: 200px; margin-right: 20px">
        <el-input size="small" v-model="params.id" placeholder="用户UID搜索"></el-input>
      </el-col>
      <el-col class="pull-right" style="width: 200px; margin-right: 20px">
        <el-input size="small" v-model="params.phone" placeholder="手机号或邮箱搜索"></el-input>
      </el-col>
      <el-col class="pull-right" style="width: 200px; margin-right: 20px">
        <el-input size="small" v-model="params.transaction_url" placeholder="用户交易链接"></el-input>
      </el-col>
      <el-col class="pull-right" style="width: 200px; margin-right: 20px">
        <el-input size="small" v-model="params.qq_id" placeholder="QQ搜索"></el-input>
      </el-col>
    </el-row>
    <el-table :data="listData" v-loading="loading" @sort-change="handleSort" show-summary>
      <el-table-column label="用户ID" width="100" sortable="custom">
        <template slot-scope="scope">
          <!-- <span @click="$router.push(`/user/${scope.row.id}`)">{{ scope.row.id }}</span> -->
          <span @click="pathToUser(scope.row.id)">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户名称" width="200">
        <template slot-scope="scope">
          <div class="user-avatar" @click="pathToUser(scope.row.id)">
            <img :src="scope.row.avatar || '/images/default-avatar.jpg'" alt />
            <span :style="`${scope.row.human_feelings === 1 ? 'color:blue' : ''}`">{{ scope.row.name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="邮箱" width="120">
        <template slot-scope="scope">
          <span @click="pathToUser(scope.row.id)">{{
          scope.row.email ? scope.row.email : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="电话号码">
        <template slot-scope="scope">
          <span @click="pathToUser(scope.row.id)">{{
          scope.row.phone ? scope.row.phone : "-"
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="recharges" label="充值次数" width="100"></el-table-column>
			<el-table-column prop="withdrawals" label="提现次数" width="100"></el-table-column> -->
      <el-table-column prop="type" label="用户类型" width="100" sortable="custom">
        <template slot-scope="{ row }">
          <el-tag v-if="row.type === 1" type="info">普通用户</el-tag>
          <el-tag v-if="row.type === 2" type="success">主播</el-tag>
          <el-tag v-if="row.type === 7" type="success">主播（新）</el-tag>
          <el-tag v-if="row.type === 3" type="primary">测试账号</el-tag>
          <el-tag v-if="row.type === 4" type="warning">代理</el-tag>
          <el-tag v-if="row.type === 5" type="warning">代&nbsp;理</el-tag>
          <el-tag v-if="row.type === 6" type="warning">试用期代理</el-tag>
          <el-tag v-if="row.type === 9" type="warning">代&nbsp;&nbsp;理</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="账户状态" width="100" sortable="custom">
        <template slot-scope="{ row }">
          <el-tag v-if="row.status === 1" type>正常</el-tag>
          <el-tag v-if="row.status === 2" type="info">冻结</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="user_tag" label="用户标签">
        <!--				<template slot-scope="{ row }">-->
        <!--					<el-tag  type="danger">{row.user_tag}}</el-tag>-->
        <!--				</template>-->
      </el-table-column>
      <el-table-column prop="account_balance" label="钻石余额" sortable="custom"></el-table-column>
      <el-table-column prop="shop_balance" label="金币余额" sortable="custom"></el-table-column>
      <el-table-column prop="coins_balance" label="coins余额"></el-table-column>
      <el-table-column prop="shop_coins_balance" label="活动商城余额"></el-table-column>
      <el-table-column prop="recharge_amount" label="总充值额" sortable="custom"></el-table-column>
      <el-table-column prop="total_take_back_amount" sortable="custom" label="总取回额"></el-table-column>
      <el-table-column prop="backpack_amount" label="背包金额"></el-table-column>
      <el-table-column prop="anchor_amount" label="渠道费"></el-table-column>
      <el-table-column prop="total_num" label="总数据"></el-table-column>
      <el-table-column label="累充领完">
        <template slot-scope="{ row }">
          <span v-if="row.welfare_status">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="加入时间" sortable="custom" width="100"></el-table-column>
      <el-table-column prop="ip" label="登录ip" width="500"></el-table-column>
      <el-table-column prop="min_roll" label="min_roll"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="{ row }">
          <el-row style="margin-bottom: 10px">
            <el-col :span="12">
              <el-button type="primary" size="small" @click="handleChange(row)">修改用户</el-button>
            </el-col>
            <el-col :span="12">
              <el-button size="small" @click="pathToUser(row.id)">详情</el-button>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px" v-if="GLOBAL.kefu_flag">
            <el-col :span="12">
              <el-button size="small" type="info" @click="setHuman(row)" v-if="row.human_feelings === 1">已人情</el-button>
              <el-button size="small" type="danger" @click="setHuman(row)" v-if="row.human_feelings === 0">未人情
              </el-button>
            </el-col>
            <el-col :span="12">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ rowInfo: row, name: 'TradeBox' }">赠送盒子</el-dropdown-item>
                  <el-dropdown-item :command="{ rowInfo: row, name: 'SendInherit' }">赠送红包</el-dropdown-item>
                  <el-dropdown-item :command="{ rowInfo: row, name: 'SendCoins' }">赠送COINS</el-dropdown-item>
                  <el-dropdown-item :command="{ rowInfo: row, name: 'SendCard' }">赠送月卡</el-dropdown-item>
                  <el-dropdown-item :command="{ rowInfo: row, name: 'SendActivityCoin' }">赠送活动币</el-dropdown-item>
                  <el-dropdown-item :command="{ rowInfo: row, name: 'SendCoupon' }">赠送优惠券</el-dropdown-item>
                  <el-dropdown-item :command="{ rowInfo: row, name: 'BoxRecordLog' }">箱子获取记录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :total="listMeta ? listMeta.total : 0"
      :current-page="listMeta ? listMeta.current_page : 1" :page-size="listMeta ? listMeta.per_page : 15"
      @current-change="handlePageChange"></el-pagination>
    <el-dialog :visible="visibleChange" title="修改用户" @close="visibleChange = false" width="400px"
      :close-on-click-modal="false">
      <el-form :model="formData" label-width="80px">
        <el-form-item prop="name" label="用户名">
          <el-input size="small" v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="手机号" v-if="GLOBAL.kefu_flag">
          <el-input size="small" v-model="formData.phone"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱" v-if="GLOBAL.kefu_flag">
          <el-input size="small" v-model="formData.email"></el-input>
        </el-form-item>
        <el-form-item prop="account_balance" label="用户余额" v-if="GLOBAL.kefu_flag">
          <el-input size="small" v-model="formData.account_balance"></el-input>
        </el-form-item>
        <el-form-item prop="shop_balance" label="用户商城余额" v-if="GLOBAL.kefu_flag">
          <el-input size="small" v-model="formData.shop_balance"></el-input>
        </el-form-item>
        <el-form-item prop="coins_balance" label="用户coins余额" v-if="GLOBAL.kefu_flag">
          <el-input size="small" v-model="formData.coins_balance" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="用户状态">
          <el-switch v-model="formData.status" active-text="正常" inactive-text="冻结" :active-value="1"
            :inactive-value="2"></el-switch>
          <br />
          <el-switch v-model="formData.is_inherit" active-text="继承" inactive-text="非继承" :active-value="1"
            :inactive-value="0" v-if="GLOBAL.kefu_flag"></el-switch>
          <br />
          <el-switch v-model="formData.is_hundred" active-text="正常百级" inactive-text="关闭标识" :active-value="1"
            :inactive-value="0" v-if="GLOBAL.kefu_flag"></el-switch>
        </el-form-item>
        <el-form-item prop="type" label="用户类型" v-if="GLOBAL.kefu_flag">
          <el-select v-model="formData.type">
            <el-option :value="1" label="普通用户"></el-option>
            <el-option :value="2" label="主播"></el-option>
            <el-option :value="7" label="主播（新）"></el-option>
            <!-- <el-option :value="3" label="测试用户"></el-option> -->
            <el-option :value="4" label="代理"></el-option>
            <el-option :value="6" label="试用期代理"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="
          formData.type === 2 || formData.type === 4 || formData.type === 6
        " prop="ratio" label="用户收益比">
          <el-input size="small" v-model="formData.ratio"></el-input>
        </el-form-item>
        <el-form-item v-if="
          formData.type === 2 || formData.type === 4 || formData.type === 6
        " prop="old_ratio" label="用户旧收益比">
          <el-input size="small" v-model="formData.old_ratio"></el-input>
        </el-form-item>
        <el-form-item v-if="
          formData.type === 2 || formData.type === 4 || formData.type === 6
        " prop="player_ratio" label="被推广玩家收益比">
          <el-input size="small" v-model="formData.player_ratio"></el-input>
        </el-form-item>
        <el-form-item v-if="
          formData.type === 2 || formData.type === 4 || formData.type === 6
        " prop="code" label="推广码">
          <el-input size="small" v-model="formData.code"></el-input>
        </el-form-item>
        <el-form-item prop="user_tag" label="用户标签">
          <el-input size="small" v-model="formData.user_tag"></el-input>
        </el-form-item>
        <el-form-item prop="pid" label="用户上级">
          <el-input size="small" v-model="formData.pid"></el-input>
        </el-form-item>
        <el-form-item prop="consumption_amount" label="消费金额" v-if="GLOBAL.kefu_flag">
          <el-input size="small" v-model="formData.consumption_amount"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="修改密码">
          <el-input size="small" v-model="formData.password"></el-input>
        </el-form-item>
        <el-form-item prop="realname" label="实名认证-姓名">
          <el-input size="small" v-model="formData.realname"></el-input>
        </el-form-item>
        <el-form-item prop="idcard" label="实名认证-姓名">
          <el-input size="small" v-model="formData.idcard"></el-input>
        </el-form-item>
        <el-form-item prop="real_name_verify_2" label="实名认证-状态">
          <el-select v-model="formData.real_name_verify_2">
            <el-option :value="0" label="未认证"></el-option>
            <el-option :value="1" label="已认证"></el-option>
            <el-option :value="2" label="认证失败"></el-option>
            <el-option :value="3" label="认证中"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="auth_time" label="auth_time">
          <el-input size="small" v-model="formData.auth_time" readonly="true"></el-input>
        </el-form-item>
        <el-form-item prop="min_roll" label="min_roll">
          <el-select v-model="formData.min_roll" placeholder="min_roll">
            <el-option :value="1" label="1">1</el-option>
            <el-option :value="2" label="2">2</el-option>
            <el-option :value="3" label="3">3</el-option>
            <el-option :value="4" label="4">4</el-option>
            <el-option :value="5" label="5">5</el-option>
            <el-option :value="6" label="6">6</el-option>
            <el-option :value="7" label="7">7</el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleChange = false">取 消</el-button>
        <el-button size="small" type="primary" @click="change" :loading="buttonLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible="visibleTradeBox" title="赠送盒子" @close="visibleTradeBox = false" width="480px"
      :close-on-click-modal="false">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-upload accept=".xls,.xlsx" :show-file-list="false" :on-success="onSuccess" :on-error="onError"
            style="display: inline-flex; margin-right: 10px" :action="action" :headers="headers">
            <el-button size="mini" type="primary" icon="el-icon-upload2">
              上传表(.xls/.xlsx)
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" icon="el-icon-download" @click="downloadExcel">
            下载模版
          </el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="demo-form-inline" v-for="item in giftBoxList" :key="item.id">
        <el-form-item :label="item.name">
          <el-input size="small" v-model="item.nums" style="width: 80px" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input-number size="mini" v-model="item.giftAddNum" style="width: 120px"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="item-btn" @click="saveGiftBox(item)">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible="visibleRedInherit" title="红包赠送" @close="visibleRedInherit = false"
      :close-on-click-modal="false" width="400px">
      <el-form :model="sendRedInheritParams" label-width="80px">
        <el-form-item prop="box_id" label="用户ID">
          <el-input v-model="sendRedInheritParams.user_id" disabled></el-input>
        </el-form-item>
        <el-form-item prop="num" label="最低">
          <el-input size="small" v-model="sendRedInheritParams.low_amount"></el-input>
        </el-form-item>
        <el-form-item prop="num" label="最高">
          <el-input size="small" v-model="sendRedInheritParams.high_amount"></el-input>
        </el-form-item>
        <el-form-item prop="num" label="充值限制">
          <el-input size="small" v-model="sendRedInheritParams.recharge_amount"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleRedInherit = false">取 消</el-button>
        <el-button size="small" type="primary" @click="sendRedInherit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 赠送商城币 -->
    <AddCoinsDialog v-model="dialogInfos" :visible="visibleCoins" @close="visibleCoins = false"
      @refresh="getTableData()"></AddCoinsDialog>
    <!-- 赠送月卡 -->
    <SendCardDialog v-model="dialogInfos" :visible="visibleCard" @close="visibleCard = false" @refresh="getTableData()">
    </SendCardDialog>
    <!-- 赠送活动商城币 -->
    <SendActivityCoinDialog v-model="dialogInfos" :visible="visibleActivityCoin" @close="visibleActivityCoin = false"
      @refresh="getTableData()"></SendActivityCoinDialog>
    <!-- 赠送优惠券 -->
    <SendCouponDialog v-model="dialogInfos" :visible="visibleCoupon" @close="visibleCoupon = false"
      @refresh="getTableData()"></SendCouponDialog>

    <!-- 用户箱子领取记录 -->
    <BoxReceiveLog v-model="dialogInfos" :visible="visibleBoxRecordLog" @close="visibleBoxRecordLog = false">
    </BoxReceiveLog>
  </div>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'
import {
  server,
  getApiData,
  patchData,
  postApiData,
  patchApiData
} from '../../http'
import {
  getCookie
} from '@/utils/cookie'
import AddCoinsDialog from '@/components/user/user_management/AddCoinsDialog.vue'
import SendCardDialog from '@/components/user/user_management/SendCardDialog.vue'
import SendActivityCoinDialog from '@/components/user/user_management/SendActivityCoinDialog.vue'
import SendCouponDialog from '@/components/user/user_management/SendCouponDialog.vue'
import BoxReceiveLog from '@/components/user/user_management/BoxReceiveLog.vue'

export default {
  components: {
    AddCoinsDialog,
    SendCardDialog,
    SendActivityCoinDialog,
    SendCouponDialog,
    BoxReceiveLog
  },
  data() {
    return {
      webUrl: window.location.host,//当前网站域名地址
      visibleBoxRecordLog: false, //用户箱子领取记录弹窗显示标志
      visibleActivityCoin: false, //赠送活动商城币弹窗显示标志
      visibleCoupon: false, //赠送优惠券弹窗显示标志
      visibleCard: false, //赠送月卡弹窗显示标志
      visibleCoins: false, //赠送商城币弹窗显示标志
      loading: false,
      params: {
        phone: '',
        email: '',
        transaction_url: '',
        name: '',
        id: '',
        status: undefined,
        type: undefined,
        page: 1,
        order: '',
        order_type: '',
        qq_id: ''
      },
      formData: {
        ratio: undefined,
        old_ratio: undefined,
        player_ratio: undefined,
        account_balance: '',
        shop_balance: '',
        coins_balance: '',
        status: 1,
        is_inherit: 0, //继承状态 0是非继承 1继承
        is_hundred: 0, //百级标识状态 0关闭百级标识 1打开百级标识
        type: 1,
        code: undefined,
        name: '',
        phone: '',
        email: '',
        user_tag: '',
        pid: '',
        consumption_amount: undefined,
        password: '',
        realname: '',
        idcard: '',
        real_name_verify_2: 0,
        auth_time: '',
        min_roll: 1
      },
      formDataTradeBox: {
        user_id: undefined
      },
      dialogInfos: undefined, //弹窗信息
      giftBoxList: [],
      visibleChange: false,
      visibleTradeBox: false,
      buttonLoading: false,
      editInfo: undefined,
      visibleRedInherit: false,
      redInheritLoading: false,
      sendRedInheritParams: {
        user_id: '',
        low_amount: 0.00,
        high_amount: 0.00,
        recharge_amount: 0.00
      }
    }
  },
  computed: {
    ...mapState({
      listData: state => state.data.userList.data,
      listMeta: state => state.data.userList.meta
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}user_exp_box_import`
    }
  },
  watch: {
    visibleChange(val) {
      if (val) {
        const {
          ratio,
          old_ratio,
          player_ratio,
          account_balance,
          shop_balance,
          coins_balance,
          status,
          is_inherit,
          is_hundred,
          type,
          code,
          user_tag,
          pid,
          name,
          phone,
          email,
          consumption_amount,
          password,
          realname,
          idcard,
          real_name_verify_2,
          auth_time,
          min_roll
        } = this.editInfo
        this.formData = {
          ratio,
          old_ratio,
          player_ratio,
          account_balance,
          shop_balance,
          coins_balance,
          status,
          is_inherit,
          is_hundred,
          type,
          code,
          user_tag,
          pid,
          name,
          phone,
          email,
          consumption_amount,
          password,
          realname,
          idcard,
          real_name_verify_2,
          auth_time,
          min_roll
        }
      }
    }
  },
  methods: {
    ...mapActions(['getUserList']),
    setHuman(rowInfo) {
      //点击人情
      let params = {
        human_feelings: rowInfo.human_feelings === 1 ? 0 : 1
      }
      this.$confirm(rowInfo.human_feelings === 1 ? '是否变为未人情？' : '是否变为已人情？', {
        type: 'warning'
      }).then(res => {
        patchData(`users_human_feelings/${rowInfo.id}`, params).then(res => {
          this.$message.success('操作成功！')
          this.getTableData()
        }).finally(() => { })
      })
    },
    //更多操作
    handleCommand(command) {
      switch (command.name) {
        case 'TradeBox':
          // 赠送盒子
          this.handTradeBox(command.rowInfo.id);
          break;
        case 'SendInherit':
          //赠送红包
          this.handleSendInherit(command.rowInfo.id);
          break;
        case 'SendCoins':
          //赠送商城coins
          this.handleSendCoins(command.rowInfo);
          break;
        case 'SendCard':
          //赠送月卡
          this.handleSendCard(command.rowInfo);
          break;
        case 'SendActivityCoin':
          //赠送活动商城币
          this.handleSendActivityCoin(command.rowInfo);
          break;
        case 'SendCoupon':
          //赠送优惠券
          this.handleSendCoupon(command.rowInfo);
          break;
        case 'BoxRecordLog':
          //箱子领取记录
          this.handleBoxRecordLog(command.rowInfo);
          break;
      }
    },
    handTradeBox(id) {
      // 赠送盒子
      this.visibleTradeBox = true
      this.getGiftBox(id) //获取钥匙数量信息
      this.formDataTradeBox.user_id = id
    },
    handleSendInherit(id) {
      //赠送红包
      this.sendRedInheritParams.user_id = id
      this.visibleRedInherit = true
    },
    handleSendCoins(rowInfo) {
      //赠送coins
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
      this.visibleCoins = true
    },
    handleSendCard(rowInfo) {
      //赠送月卡
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
      this.visibleCard = true
    },
    handleSendActivityCoin(rowInfo) {
      //赠送活动商城币
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
      this.visibleActivityCoin = true
    },
    handleSendCoupon(rowInfo) {
      //赠送优惠券
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
      this.visibleCoupon = true
    },
    handleBoxRecordLog(rowInfo) {
      //用户箱子领取记录
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
      this.visibleBoxRecordLog = true
    },
    sendRedInherit() {
      postApiData("sendRedInherits", this.sendRedInheritParams)
        .then(res => {
          this.$message.success('Success')
          this.visibleRedInherit = false
        })
    },
    getTableData() {
      this.loading = true
      this.getUserList(this.params).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      this.params.page = page
      this.getTableData()
    },
    handleChange(row) {
      this.visibleChange = true
      this.editInfo = row
    },
    handleSearch() {
      this.params.page = 1
      this.getTableData()
    },
    change() {
      this.buttonLoading = true
      patchData(`users/${this.editInfo.id}`, {
        ...this.formData
      })
        .then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.visibleChange = false
            this.getTableData()
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    getGiftBox(id) {
      //获取赠送盒子的钥匙数量
      let params = {
        user_id: id
      }
      getApiData(`user_exp_boxes`, params, {})
        .then(res => {
          if (res) {
            this.giftBoxList = res
          }
        })
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
      this.getData()
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    downloadExcel() {
      //下载excel模版
      window.open('./excel/批量发箱子.xlsx', '_blank')
    },
    saveGiftBox(data) {
      //修改赠送盒子的钥匙数量
      this.buttonLoading = true
      let params = {
        user_id: this.formDataTradeBox.user_id,
        box_id: data.id,
        num: data.giftAddNum,
      }
      patchApiData(`user_exp_boxes`, params)
        .then(res => {
          if (res.code) {
            this.$message.success(res.msg)
            this.visibleChange = false
            this.getGiftBox(this.formDataTradeBox.user_id)
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    handleSort(column) {
      this.params.order = column.prop
      this.params.order_type = column.order === 'ascending' ? 'asc' : 'desc'
      this.params.page = 1
      this.getTableData()
    },
    pathToUser(id) {
      let routeData = this.$router.resolve({
        path: `/user/${id}`
      })
      window.open(routeData.href, '_blank')
    }
  },
  created() {
    // 客服后台不请求这个接口
    if (window.location.host != 'rndhskew4i.m9skins.com') {
      this.getTableData()
    }
  }
}

</script>
<style lang="less" scoped>

</style>
